<template>
  <base-layout pageTitle="Profile">
        <hero v-if="$store.state.account.isAuthenticated" :userEmail="user.phone">
            <ion-button @click="signOut">sign out</ion-button>
        </hero>
          <div v-else>
            <hero>
            <router-link :to="{ name:'register' }" replace>
              <ion-button > Register </ion-button>
            </router-link>
            <router-link :to="{ name:'signIn' }" replace>
              <ion-button > Login </ion-button>
            </router-link>
          </hero>
          </div>
          <div class="flex">
          </div>

  </base-layout>
</template>

<script>
import { IonButton } from '@ionic/vue';
import { ref } from 'vue'
import { useRouter } from 'vue-router'
import { useStore } from 'vuex'
import Hero from '@/components/Hero.vue';
export default  {
  name: 'Tab2',
  components: { Hero, IonButton },
  data(){
    return {
      amount: 0
    }
  },
  setup(){
    const isLoggedIn = ref(true)
    const router = useRouter()
    const store = useStore()
    const user = ref()

    try {
      user.value = store.state.account.user
    } catch { user.value = '' }
    const signOut = () => { store.dispatch('account/logout') }
   
    return {isLoggedIn, router, user, signOut}
  },
  computed: {
  
  }
}
</script>